export default __webpack_public_path__ + "static/media/2136.f4526a30.png";